import { Alert, Form as AntdForm, Radio as AntdRadio, Divider } from 'antd'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  ${props => props.width && `width: ${props.width}`}
`

export const FormItemDiv = styled(AntdForm.Item)`
  margin-top: 0px;
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '-20px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
  .ant-form-item-control-input {
    min-height: 0px;
  }
`

export const Form = styled(AntdForm)`
  row-gap: 20px;
  display: flex;
  flex-direction: column;
`
export const StyledDivider = styled(Divider)`
  margin: ${props => (props.margin ? props.margin : '20px 0')};
`
export const FormHeading = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0')};
`
export const SecondaryHeading = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0')};
`
export const FlexWrap = styled(Flex)`
  flex-wrap: ${props => (props.flexWrap ? 'nowrap' : 'wrap')};
  flex-direction: ${props => (props.flexDirection ? 'column' : '')};
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
  margin-top: ${props => (props.margintop ? props.margintop : '0')};
  margin-left: ${props => (props.marginLeft ? props.marginLeft : '0')};
`
export const TypeGroup = styled(Flex)`
  display: flex;
  flex-wrap: wrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: -1em;
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
`
export const RadioGroup = styled(AntdRadio.Group)`
  display: ${props => (props?.displayFlex ? 'flex' : 'grid')};
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: ${props => (props?.gap ? props?.gap : '36px')};
  margin-top: 8px;

  .ant-radio-wrapper {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
`
export const RadioGroups = styled(AntdRadio.Group)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const SelectInputDiv = styled(Flex)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '20px'} !important;
  margin-top: ${props =>
    props.margintop ? props.margintop : '0px'} !important;
  align-items: flex-end;
  position: sticky;
  align-items: stretch;
  width: ${props => (props.width ? props.width : '100%')};
  border-radius: 8px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: ${props =>
      props?.borderright ? '8px' : 0} !important;
    border-bottom-right-radius: ${props =>
      props?.borderright ? '8px' : 0} !important;
    border-right: ${props =>
      props?.borderright
        ? `${props?.borderright} solid  #e9e9e9`
        : 0} !important;

    border-top-left-radius: ${props =>
      props?.borderleft ? '8px' : 0} !important;
    border-bottom-left-radius: ${props =>
      props?.borderleft ? '8px' : 0} !important;
  }
`
export const StyledInput = styled(Input)`
  padding: ${props => props.InputStyle && '25px'};
  width: ${props => props.InputStyle && '390px'};
  border-radius: ${props => props.InputStyle && '10px'};
  box-shadow: ${props =>
    props.InputStyle && '0px 2px 6px 0px rgba(123, 97, 255, 0.15)'};
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background: ${props => props?.background || 'inherit'};
`
export const StyledInputLeft = styled(Input)`
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
`

export const RedText = styled.p`
  font-size: ${FONT.F_SM};
  line-height: 1.5715;
  color: ${COLORS.ERROR};
`
export const BorderedDiv = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  background: ${COLORS.PRIMARY_GREY_T_98};
  opacity: 0.67;
  padding: 10px 20px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  height: 38px;
`

export const SuffixText = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 24px;
  color: ${COLORS.GREY_P_100};
`
export const AlertText = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-left: 5px;
`
export const AlertTexts = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-left: 5px;
`
export const StyledAlert = styled(Alert)`
  border: none;
  border-radius: 10px;
  margin: ${props => (props?.margin ? props?.margin : 0)};
`
export const StyledAlerts = styled(Alert)`
  &.ant-alert-info {
    background-color: white !important ;
    border: none !important;
  }
  border: none;
  border-radius: 10px;
  margin: ${props => (props?.margin ? props?.margin : 0)};
`
export const CopyLinkDiv = styled.div`
  cursor: pointer;
`
export const StyledInputCustom = styled(Input)`
  height: auto;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  background: #fafafb;
  min-width: 72px;

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
    inputmode: numeric;
  }
`
